import { render, staticRenderFns } from "./AndroidTutorials.vue?vue&type=template&id=01425a3e&scoped=true"
import script from "./AndroidTutorials.vue?vue&type=script&lang=js"
export * from "./AndroidTutorials.vue?vue&type=script&lang=js"
import style0 from "./AndroidTutorials.vue?vue&type=style&index=0&id=01425a3e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.4.36_css-loader@6.11.0_webpack@5.93.0__lodash@4.17.21__7r3p777cvsu74h5lnod2543tei/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01425a3e",
  null
  
)

export default component.exports